import { render, staticRenderFns } from "./OrderUpdateMcStatusPage.vue?vue&type=template&id=276ff2d6&scoped=true&"
import script from "./OrderUpdateMcStatusPage.vue?vue&type=script&lang=ts&"
export * from "./OrderUpdateMcStatusPage.vue?vue&type=script&lang=ts&"
import style0 from "./OrderUpdateMcStatusPage.vue?vue&type=style&index=0&id=276ff2d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ff2d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
